export class meetingData_pObj {
    country: string;
    date: string;
    filter: number;
    inplay: boolean;
    sport: string;
    id:number
}